const apiVersion = 'v1'

export const BASE_PATH = `api/${apiVersion}/clients/:client_session_id/releases/`
